<template>
<div>
    <div class="sub-navi">
        <ul>
            <li><a v-bind:href="lastrouter" class="btn_prev"><img src="../../common/images/common/left_s.png" alt="left" width="19" height="19"></a></li>
            <li><span><a href="/service/knowledge" v-bind:title="$t('tlTyreKnowledge')" id="tlTyreKnowledge" :class="selectedid == 'tlTyreKnowledge' ? 'active': ''">{{$t('tlTyreKnowledge')}}</a></span></li>
            <li><span><a href="/service/maintenance" v-bind:title="$t('tlMaintenance')" id="tlMaintenance" :class="selectedid == 'tlMaintenance' ? 'active': ''">{{$t('tlMaintenance')}}</a></span></li>
            <li><span><a href="/service/rotation" v-bind:title="$t('tlRotation')" id="tlRotation" :class="selectedid == 'tlRotation' ? 'active': ''">{{$t('tlRotation')}}</a></span></li>
            <li><span><a href="/service/driving" v-bind:title="$t('tlDrivingTips')" id="tlDrivingTips" :class="selectedid == 'tlDrivingTips' ? 'active': ''">{{$t('tlDrivingTips')}}</a></span></li>
            <li><span><a href="/service/sidewall" v-bind:title="$t('tlSidewallInfo')" id="tlSidewallInfo" :class="selectedid == 'tlSidewallInfo' ? 'active': ''">{{$t('tlSidewallInfo')}}</a></span></li>
            <li><span><a href="/service/warranty" v-bind:title="$t('tlWarranty')" id="tlWarranty" :class="selectedid == 'tlWarranty' ? 'active': ''">{{$t('tlWarranty')}}</a></span></li>
            <li><span><a href="/service/download" v-bind:title="$t('tlDownload')" id="tlDownload" :class="selectedid == 'tlDownload' ? 'active': ''">{{$t('tlDownload')}}</a></span></li>
            <li><a v-bind:href="nextrouter" class="btn_next"><img src="../../common/images/common/right_s.png" alt="right" width="19" height="19"></a></li>
        </ul>
    </div>
</div>
</template>

<script>

export default {
    name: "SubNavi",
     props: ["selectedid", "lastrouter", "nextrouter"]
}
</script>



// WEBPACK FOOTER //
// src/components/service/subnavi.vue